import moment from "moment/moment";
import { useEffect, useState } from "react";
import CardHeaderDashboardOnOff from "../../../utils/cardHeaderDashboardOnOff";
import { useLocation, useOutletContext } from "react-router-dom";
import { requestToServer } from "../../../utils/appUtils";

const ROUTE_URL = "/conf_lsn";


const CardCHConn = (props) => {
    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState(2);
    const [date, setDate] = useState();
    const [onoff, setOnoff] = useState(props.butchState);
    const [loadingStatus, setLoadingStatus] = useState(true)

    const [serverData, setServerData] = useState(true);
    serverData?.data?.forEach((item) => {
        item.status = 0
    })
    const { showErrorPage, messageBox } = useOutletContext();

    console.log('onoff CardCHConn', onoff);
    console.log('props.butchState CardCHConn', props.butchState);

    useEffect(() => {
        requestToServer(ROUTE_URL, { method: 'GET' }, setServerData, showErrorPage, true);
    }, [])

    let services = [
        { id: 1, name: "СЧ ПУ-ЛСН", status: status, date: date, href: 'chpylsnconnect' },
    ];

    useEffect(() => {
        if (onoff) {
            window.timer = setInterval(() => {
                console.log(onoff ? 'VKL CardCHConn' : "vikl CardCHConn");
                if (onoff) {
                    setLoadingStatus(false)
                    setStatus(0);
                    setDate((new Date()).toUTCString());
                } else {
                    setLoadingStatus(false)
                    setStatus(2);
                    clearInterval(window.timer);
                }
            }, 5000);
        } else {
            clearInterval(window.timer);
        }
    }, [onoff])

    const switchClick = async (event) => {
        if (loading) return;
        setOnoff(!onoff);
        localStorage.setItem('chlsn', !onoff)
        if (onoff) {
            setStatus(2);
        } else {
            setStatus(0);
        }
    }

    const handleClick = (event) => {
        if (loading) return;
        event.preventDefault();
        event.target.blur();
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
        }, 1000);
    }

    let styleCard = {};
    let classCard = "card h-100";
    if (props.dashboard === false) {
        styleCard = { minHeight: "var(--clientheight)" };
        classCard = "card border-0";
    }

    return (
        <div className={classCard} style={styleCard}>
            <CardHeaderDashboardOnOff loading={loading} onClick={handleClick} switchClick={switchClick} defCheck={onoff}>
                Доступность Компонентов СЧ ПУ-ЛСН
            </CardHeaderDashboardOnOff>
            <div className="card-body" style={{ fontSize: "0.85rem" }}>
                {(
                    serverData?.data?.map((item, index, array) => {
                        return (
                            <div key={item.id} className={`gap-2 col-12 d-flex align-items-center ${index == 0 ? "" : "mt-1"}`}>
                                {loadingStatus ? (
                                    <div style={{ width: "1.25em", height: "1.25em", margin: `6.5px 0px` }} className=" spinner-border spinner-border-sm text-primary"></div>
                                ) : (
                                    <i className={`fs-5 ${item.status == 0 ? "bi-check-circle-fill text_green" : item.status == 1 ? "bi-x-circle-fill text-danger" : item.status == 2 ? "bi-check-circle-fill text_yellow" : "bi-x-circle-fill text-muted"}`}></i>
                                )}
                                <div>
                                    <span className="link-info">
                                        {item.address ? <a className="link-info" href={`${item.address}`}>{item.name}</a> : item.name} - <small>{moment(item.date).isValid() ? moment.utc(item.date).local().format("DD.MM.YYYY HH:mm:ss") : item.date}</small>
                                    </span>
                                </div>
                            </div>
                        );
                    })
                )}
            </div>
        </div>
    );
}

export default CardCHConn;